/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { AddIpWhiteListModule } from './add-ip-white-list/add-ip-white-list.module';
import { IpWhiteListComponent } from './ip-white-list.component';
import { ModifyIpWhiteListModule } from './modify-ip-white-list/modify-ip-white-list.module';
import { RemoveIpWhiteListModule } from './remove-ip-white-list/remove-ip-white-list.module';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        AddIpWhiteListModule,
        ModifyIpWhiteListModule,
        RemoveIpWhiteListModule,
    ],
    declarations: [IpWhiteListComponent],
    exports: [IpWhiteListComponent],
})
export class IpWhiteListModule { }
